var map = {
	"./tip-01.png": 7714,
	"./tip-02.png": 2136,
	"./tip-03.png": 3587,
	"./tip-04.png": 3951,
	"./tip-05.png": 6119,
	"./tip-06.png": 391,
	"./tip-07.png": 2343,
	"./tip-08.png": 7798,
	"./tip-09.png": 3101,
	"./tip-10.png": 5932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9713;